module.exports = __webpack_public_path__ + "img/1580289072.be9e8681.jpg";